/* ============================================================
   MetaSync · Motion Layer
   מנוע תנועה מונחה-גלילה. mobile-first, rAF יחיד, מכבד
   prefers-reduced-motion ואת מתג "עצירת אנימציות" בנגישות.
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduced = function () {
    return root.classList.contains('a11y-motion') ||
      (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  };

  /* ---------- 1 · פיצול כותרות למילים (חשיפה במסכה) ---------- */
  function splitWords(el) {
    if (el.dataset.split === 'done') return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) if (n.nodeValue.trim()) nodes.push(n);
    var i = 0;
    nodes.forEach(function (node) {
      var frag = document.createDocumentFragment();
      node.nodeValue.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        var w = document.createElement('span'); w.className = 'ms-w';
        var inner = document.createElement('span'); inner.className = 'ms-w__i';
        inner.textContent = part;
        inner.style.transitionDelay = (i++ * 42) + 'ms';
        w.appendChild(inner); frag.appendChild(w);
      });
      node.parentNode.replaceChild(frag, node);
    });
    el.dataset.split = 'done';
  }

  /* ---------- 2 · תשתית תצפית ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.classList.add('is-in');
      if (el.hasAttribute('data-count')) runCount(el);
      io.unobserve(el);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  function observe(sel) { document.querySelectorAll(sel).forEach(function (el) { io.observe(el); }); }

  /* ---------- 3 · מונה מספרים ---------- */
  function runCount(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;
    if (reduced()) { el.textContent = String(target); return; }
    var dur = 1100, t0 = performance.now(), dec = (String(target).split('.')[1] || '').length;
    (function step(t) {
      var p = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * e).toFixed(dec);
      if (p < 1) requestAnimationFrame(step);
    })(t0);
  }

  /* ---------- 4 · לולאת גלילה אחת (פרלקסה + התקדמות) ---------- */
  var parallax = [], progress = [], ticking = false;

  function collect() {
    parallax = [].slice.call(document.querySelectorAll('[data-parallax]'));
    progress = [].slice.call(document.querySelectorAll('[data-progress]'));
  }

  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    if (!reduced() && window.innerWidth > 900) {
      for (var i = 0; i < parallax.length; i++) {
        var el = parallax[i], r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        var amt = parseFloat(el.getAttribute('data-parallax')) || 0.15;
        var mid = r.top + r.height / 2 - vh / 2;
        el.style.setProperty('--py', (-mid * amt).toFixed(2) + 'px');
      }
    }
    for (var j = 0; j < progress.length; j++) {
      var p = progress[j], pr = p.getBoundingClientRect();
      var raw = (vh - pr.top) / (vh + pr.height);
      p.style.setProperty('--sp', Math.max(0, Math.min(1, raw)).toFixed(4));
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

  /* ---------- 5 · כפתורים מגנטיים (מצביע מדויק בלבד) ---------- */
  function magnetic() {
    if (!window.matchMedia || !window.matchMedia('(pointer:fine)').matches) return;
    document.querySelectorAll('[data-magnetic]').forEach(function (b) {
      b.addEventListener('pointermove', function (e) {
        if (reduced()) return;
        var r = b.getBoundingClientRect();
        b.style.setProperty('--mx', ((e.clientX - r.left - r.width / 2) * 0.22).toFixed(1) + 'px');
        b.style.setProperty('--my', ((e.clientY - r.top - r.height / 2) * 0.28).toFixed(1) + 'px');
      });
      b.addEventListener('pointerleave', function () {
        b.style.setProperty('--mx', '0px'); b.style.setProperty('--my', '0px');
      });
    });
  }

  /* ---------- 6 · סרגל CTA דביק במובייל ---------- */
  function stickyCta() {
    var bar = document.querySelector('[data-sticky-cta]');
    if (!bar) return;
    var hero = document.querySelector('.m2-hero, .m2-phero');
    if (!hero) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { bar.classList.toggle('on', !e.isIntersecting); });
    }, { threshold: 0, rootMargin: '-90% 0px 0px 0px' }).observe(hero);
  }

  /* ---------- 7 · אתחול ---------- */
  function init() {
    document.querySelectorAll('[data-anim="split"]').forEach(splitWords);
    observe('[data-anim]');
    observe('[data-count]');
    collect();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { collect(); onScroll(); }, { passive: true });
    magnetic();
    stickyCta();
    root.classList.add('ms-motion-ready');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ---------- לולאת הצאט בטלפון (v3) ---------- */
(function () {
  'use strict';
  var slow = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-s3-chat]').forEach(function (box) {
    var data;
    try { data = JSON.parse(box.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
    if (!data || !data.length) return;
    var list = box.querySelector('.s3-ph__msgs'), typ = box.querySelector('.s3-typ'), START = Math.min(4, data.length), n = START, t;
    function paint() {
      list.innerHTML = '';
      data.slice(0, n).forEach(function (m) {
        var d = document.createElement('div');
        d.className = 's3-msg ' + (m.from === 'user' ? 's3-msg--u' : 's3-msg--b');
        d.textContent = m.text;
        var tm = document.createElement('time'); tm.textContent = m.time || ''; d.appendChild(tm);
        list.appendChild(d);
      });
    }
    function tick() {
      if (slow) { n = data.length; paint(); return; }
      if (n >= data.length) { t = setTimeout(function () { n = START; typ.classList.remove('on'); paint(); tick(); }, 5000); return; }
      if (data[n].from !== 'user') {
        typ.classList.add('on');
        t = setTimeout(function () { typ.classList.remove('on'); n++; paint(); tick(); }, 1450);
      } else {
        t = setTimeout(function () { n++; paint(); tick(); }, 1250);
      }
    }
    paint(); tick();
  });
})();
/* ---------- סרגל השבוע החי (§03) ---------- */
(function () {
  'use strict';
  document.querySelectorAll('[data-week-list]').forEach(function (list) {
    var sec = list.closest('section'); if (!sec) return;
    var rail = sec.querySelector('[data-week-rail]'); if (!rail) return;
    var ticks = rail.querySelectorAll('.s3-ruler span');
    var items = list.querySelectorAll('li'); if (!items.length) return;
    function mark(li) {
      var em = li.querySelector('.s3-wk__when em');
      var day = em ? em.textContent.trim() : '';
      ticks.forEach(function (t) { t.classList.toggle('on', t.getAttribute('data-day') === day); });
      items.forEach(function (x) { x.classList.toggle('act', x === li); x.classList.toggle('dim', x !== li); });
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) mark(e.target); });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    items.forEach(function (li) { io.observe(li); });
  });
})();
/* ---------- SAFETY NET: שום תוכן לא נשאר מוסתר ---------- */
(function () {
  'use strict';
  function revealAll() {
    document.querySelectorAll('[data-anim]:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 1.4 && r.bottom > -200) el.classList.add('is-in');
    });
  }
  window.addEventListener('scroll', revealAll, { passive: true });
  window.addEventListener('load', revealAll);
  setTimeout(revealAll, 1200);
  setTimeout(function () {
    document.querySelectorAll('[data-anim]:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 3) el.classList.add('is-in');
    });
  }, 3000);
})();